import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"
import { NEXT_NOTIFICATION_QUERY_KEY } from "@/services/queryKeys"

const { isLoggedIn } = useAuth()

export type RetrieveNextNotificationResponse = {
  id: string
  contents: string
}

export type RetrieveNextNotificationQuery = {
  lastSeenId?: string | null
}

const retrieveNextNotification = async (
  query?: RetrieveNextNotificationQuery
) => {
  const { body: notification } = await api.get<
    RetrieveNextNotificationResponse | ""
  >("/notifications/next/", {
    query: query,
  })

  return notification
}

export const useNextNotification = (
  query: MaybeRef<RetrieveNextNotificationQuery>
) =>
  useQuery({
    queryKey: [NEXT_NOTIFICATION_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      retrieveNextNotification(query_),
    staleTime: Infinity,
    enabled: isLoggedIn,
  })
